import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ApiService } from "../../services/api.service";
import { catchError, map, switchMap, throwError } from "rxjs";
import { Store } from "@ngrx/store";
import { ADD_MESSAGE } from "../messages/messages.actions";
import { HttpErrorResponse } from "@angular/common/http";
import { ANAGRAFICA, ANAGRAFICA_SUCCESS, CAMBIO_PASSWORD, CAMBIO_PASSWORD_SUCCESS, GET_BOARD_LIST, GET_BOARD_LIST_SUCCESS, ORARI_CHIUSURE, ORARI_CHIUSURE_PUT, ORARI_CHIUSURE_PUT_SUCCESS, ORARI_CHIUSURE_SUCCESS } from "./punto-poste-management.actions";
import { IResponseAnagrafica } from "../../interfaces/anagrafica";
import { IResponseCambioPassword } from "../../interfaces/cambio-password";
import { IResponseOrariChiusure } from "../../interfaces/orari-chiusure";
import { IResponseBacheca } from "../../interfaces/bacheca";


@Injectable()
export class PuntoPosteManagementEffects {

  retrieveAnagrafica$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ANAGRAFICA),
      switchMap(() => this.api.retrieveAnagrafica()),
      map((responseAnagrafica: IResponseAnagrafica) => {
        return ANAGRAFICA_SUCCESS({ responseAnagrafica });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveCambioPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CAMBIO_PASSWORD),
      switchMap(({payload}) => this.api.retrieveCambioPassword(payload)),
      map((responseCambioPassword: IResponseCambioPassword) => {
        return CAMBIO_PASSWORD_SUCCESS({ responseCambioPassword });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveOrariChiusure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ORARI_CHIUSURE),
      switchMap(() => this.api.retrieveOrariChiusure()),
      map((responseOrariChiusure: IResponseOrariChiusure) => {
        return ORARI_CHIUSURE_SUCCESS({ responseOrariChiusure });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrievePutOrariChiusure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ORARI_CHIUSURE_PUT),
      switchMap(({payload}) => this.api.retrievePutOrariChiusure(payload)),
      map((responseOrariChiusurePut: IResponseOrariChiusure) => {
        return ORARI_CHIUSURE_PUT_SUCCESS({ responseOrariChiusurePut });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveGetBacheca$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GET_BOARD_LIST),
      switchMap(({payload}) => this.api.retrieveBacheca(payload)),
      map((responseBacheca: IResponseBacheca) => {
        return GET_BOARD_LIST_SUCCESS({ responseBacheca });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store
  ) {}


  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
